export default __webpack_public_path__ + "static/media/one.153a1fcc.jpg";